import { atom } from "jotai";
import type { IIndicatorCategory } from "types/graphqlTypes";

export const SELECTED_CATEGORY_ATOM = atom<IIndicatorCategory | null>(null);
export const INDICATOR_SEARCH_QUERY_ATOM = atom<string>("");
